<template>
<div>
    <div v-if="ie=='i'">
        <!-- 洪都拉斯(HND)进口提单明细 -->
        <el-card class="partItem">
            <div slot="header">
                <span class="headTitle">运输信息</span>
            </div>
            <table>
                <tbody>
                    <tr>
                        <th>提单号</th>
                        <td colspan="3">{{billInfo.BlNumber}}</td>
                    </tr>
                    <tr>
                        <th width="25%">船名</th>
                        <td width="25%">{{billInfo.Ship}}</td>
                        <th width="25%">航次号</th>
                        <td width="25%">{{billInfo.VoyageNumber}}</td>
                    </tr>
                    <tr>
                        <th>船运公司</th>
                        <td>{{billInfo.ShipCompany}}</td>
                        <th>起运港</th>
                        <td>{{billInfo.LoadingPort}}</td>
                    </tr>
                    <tr>
                        <th>卸货港</th>
                        <td>{{billInfo.LandingPort}}</td>
                        <th>来源国</th>
                        <td>{{billInfo.Country}}</td>
                    </tr>
                    <tr>
                        <th>中转国</th>
                        <td>{{billInfo.TransitCountry}}</td>
                        <th>目的国</th>
                        <td>{{billInfo.DestinationCountry}}</td>
                    </tr>
                    <tr>
                        <th>通知人</th>
                        <td>{{billInfo.Notify}}</td>
                        <th>通知人地址</th>
                        <td>{{billInfo.NotifyAddress}}</td>
                    </tr>
                    <tr>
                        <th>集装箱号</th>
                        <td>{{billInfo.ContainerNum}}</td>
                        <th>集装箱拼箱/整箱</th>
                        <td>{{billInfo.Status}}</td>
                    </tr>
                    <tr>
                        <th>总标准箱数</th>
                        <td>{{billInfo.TeusQuantity}}</td>
                        <th>子项标准箱数</th>
                        <td>{{billInfo.SubTeusContainer}}</td>
                    </tr>
                    <tr>
                        <th>包装类型</th>
                        <td>{{billInfo.Package}}</td>
                        <th>货柜尺寸</th>
                        <td>{{billInfo.Size}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
    <div v-if="ie=='e'">
        <!-- 洪都拉斯(HND)出口提单明细 -->
        <el-card class="partItem">
            <div slot="header">
                <span class="headTitle">运输信息</span>
            </div>
            <table>
                <tbody>
                    <tr>
                        <th>提单号</th>
                        <td colspan="3">{{billInfo.BlNumber}}</td>
                    </tr>
                    <tr>
                        <th width="25%">船名</th>
                        <td width="25%">{{billInfo.Ship}}</td>
                        <th width="25%">航次号</th>
                        <td width="25%">{{billInfo.VoyageNumber}}</td>
                    </tr>
                    <tr>
                        <th>船运公司</th>
                        <td>{{billInfo.ShipCompany}}</td>
                        <th>起运港</th>
                        <td>{{billInfo.LoadingPort}}</td>
                    </tr>
                    <tr>
                        <th>卸货港</th>
                        <td>{{billInfo.LandingPort}}</td>
                        <th>来源国</th>
                        <td>{{billInfo.OriginCountry}}</td>
                    </tr>
                    <tr>
                        <th>中转国</th>
                        <td>{{billInfo.TransitCountry}}</td>
                        <th>目的国</th>
                        <td>{{billInfo.Country}}</td>
                    </tr>
                    <tr>
                        <th>通知人</th>
                        <td>{{billInfo.Notify}}</td>
                        <th>通知人地址</th>
                        <td>{{billInfo.NotifyAddress}}</td>
                    </tr>
                    <tr>
                        <th>集装箱号</th>
                        <td>{{billInfo.ContainerNum}}</td>
                        <th>集装箱拼箱/整箱</th>
                        <td>{{billInfo.Status}}</td>
                    </tr>
                    <tr>
                        <th>包装类型</th>
                        <td>{{billInfo.Package}}</td>
                        <th>货柜尺寸</th>
                        <td>{{billInfo.Size}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
</div>
</template>

<script>
export default {
    props:["billInfo","ie"],
    data() {
        return {

        };
    },
    methods: {
        
    },
    mounted() {

    },
};
</script>

<style lang="scss" scoped>
.partItem {
    margin-bottom: 20px;
    ::v-deep .el-card__header {
        padding: 10px 20px;
        .headTitle {
            display: inline-block;
            padding-left: 10px;
            font-size: 14px;
            border-left: 2px solid var(--themeColor);
            font-weight: bold;
        }
    }
}
table {
    width: 100%;
    border-collapse: collapse;
    tr {
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
        th,
        td {
            font-size: 12px;
            color: #666;
            height: 40px;
            border: 1px solid #eaeaea;
            text-align: center;
        }
        th {
            background-color: #f5f7fa;
            font-weight: 700;
        }
        .bg {
            background-color: var(--themeColor);
            color: #fff;
            font-weight: 700;
            opacity: 0.8;
        }
    }
}
</style>